export default __webpack_public_path__ + "static/media/enrolment-policy-icon.7c13db1d.svg";